import { render, staticRenderFns } from "./BodyPartTabs.vue?vue&type=template&id=72fa1688&"
import script from "./BodyPartTabs.vue?vue&type=script&lang=js&"
export * from "./BodyPartTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports